export enum DatePreference {
    'mm/dd/yyyy' = 0,
    'dd/mm/yyyy' = 1,
    'yyyy/mm/dd' = 2
}

export enum TimePreference {
    '12 hour' = 0,
    '24 hour' = 1,
}

export const TIME_PREF_12H = TimePreference['12 hour'];
export const TIME_PREF_24H = TimePreference['24 hour'];

export enum DateFnsDateFormat {
    'MM/dd/yyyy' = 0,
    'dd/MM/yyyy' = 1,
    'yyyy/MM/dd' = 2,
}

export enum DateFnsTimeFormat {
    'hh:mm a' = 0,
    'HH:mm' = 1,
}
